var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"agm-message"}},[(_vm.show)?_c('div',{staticClass:"agm-message",style:({ top: `${_vm.winHeight + _vm.spacing}px !important` })},[_c('span',{staticClass:"agm-message-text",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }